<template>
  <div class="task-list">
    <div class="list-box"
         v-if="!showBatch">
      <myScroll style="width:100%;height:100%">
        <el-table :border="false"
                  @row-click="showTaskDialog"
                  @selection-change="changeSelect"
                  :header-cell-style="{background:'#efeff5',padding: '6px 0'}"
                  :data="list">
          <el-table-column v-if="userInfo.RoleType !== 4"
                           type="selection"
                           header-align="center"
                           width="45">
          </el-table-column>
          <el-table-column v-else
                           header-align="center"
                           width="5">
          </el-table-column>
          <el-table-column>
            <template slot="header">
              <div>
                <span>
                  <el-input size="mini"
                            prefix-icon="el-icon-search"
                            :placeholder="$t('model.SearchTaskName')"
                            v-model="condition.Name"
                            clearable
                            @change="search"
                            class="search"></el-input>
                </span>
                <span>
                  <SortControl @sortList="sortList"
                               :orderBy="condition.sortValue">
                    <template slot="sort">
                      <el-select size="mini"
                                 @change="search"
                                 placeholder="Orderby"
                                 v-model="condition.sortBy"
                                 class="select">
                        <el-option v-for="item in sortType"
                                   :key="item.name"
                                   :label="item.name"
                                   :value="item.value"></el-option>
                      </el-select>
                    </template>
                  </SortControl>
                </span>
              </div>

            </template>
            <template slot-scope="scope">
              <div class="flex-container">
                <svg-icon :iconClass="scope.row.icon"
                          :class="scope.row.color"></svg-icon>
                <div class="table-text">
                  <span :class="scope.row.color!== 'Danger'?'':'Danger'"
                        class="text text-left">
                    {{scope.row.Name}}
                  </span>
                  <span class="text completionRate text-right"
                        v-if="scope.row.TaskType !== 2">
                    {{scope.row.CompletionRate}}%
                  </span>
                  <span v-if="scope.row.Concrete"
                        class="text completionRate text-right"> {{$t('task.Concrete')}}:{{scope.row.Concrete}}%</span>
                  <span class="text text-small text-left"
                        v-if="!scope.row.AssignedUserNames">{{scope.row.TaskPhaseName}}</span>
                  <span class="text text-small text-left"
                        v-if="scope.row.AssignedUserNames">{{scope.row.AssignedUserNames}} {{scope.row.TaskPhaseName ? "("+scope.row.TaskPhaseName+")":""}}</span>
                  <span class="text text-small text-right">{{scope.row.EndDate?scope.row.EndDate.substring(0,10): ''}}</span>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </myScroll>
    </div>
    <div v-if="batchIds.length>0 && !showBatch"
         class="buttonDiv">
      <el-tooltip :content="$t('model.BatchEdit')"
                  placement="bottom"
                  effect="light">
        <el-button :disabled="batchIds.length<1"
                   @click="toBatch"
                   circle
                   type="primary"
                   icon="el-icon-edit">
        </el-button>
      </el-tooltip>
    </div>

    <batch v-if="showBatch"
           @closeDialog="closeBatchDialog"></batch>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SortControl from '@components/common/sortBtnList'
import batch from './batch'

export default {
  data () {
    return {
      showBatch: false,
      condition: {
        Name: null,
        OrderBy: 'LastUpdatedOn desc',
        sortValue: 'desc',
        sortBy: 'LastUpdatedOn'
      },
      batchIds: [],
      sortType: [
        {
          name: this.$t('task.Name'),
          value: 'Name'
        }, {
          name: this.$t('task.CreatedOn'),
          value: 'CreatedOn'
        }, {
          name: this.$t('task.UpdatedOn'),
          value: 'LastUpdatedOn'
        }, {
          name: this.$t('task.DueDate'),
          value: 'EndDate'
        }]
    }
  },
  computed: {
    ...mapState(['userInfo', 'plan']),
    list () {
      return this.$store.state.diag.data.taskList
    }
  },
  created () {
    this.$store.commit('diag/setBatchTaskIds', [])
  },
  mounted () {
    this.condition.Name = this.$store.state.diag.params.condition.Name
    if (this.$store.state.diag.params.taskSortby.sortBy === '' || this.$store.state.diag.params.taskSortby.sortValue === '') {
      this.condition.OrderBy = 'LastUpdatedOn desc'
      this.condition.sortValue = 'desc'
      this.condition.sortBy = 'LastUpdatedOn'
    } else {
      this.condition.OrderBy = this.$store.state.diag.params.taskSortby.orderBy
      this.condition.sortBy = this.$store.state.diag.params.taskSortby.sortBy
      this.condition.sortValue = this.$store.state.diag.params.taskSortby.sortValue
    }
    if (this.$store.state.diag.data.refreshTaskList) {
      this.$store.dispatch('diag/getTasksList')
      this.$store.commit('diag/setRefreshTaskList', false)
    }
  },
  watch: {
  },
  methods: {
    clearFilter () {
      this.condition = {
        Name: null
      }
      this.$store.dispatch('diag/search', this.condition)
    },
    search () {
      this.condition.OrderBy = this.condition.sortBy + ' ' + this.condition.sortValue
      this.$store.commit('diag/setTaskSortby', this.condition)
      this.$store.dispatch('diag/search', this.condition)
    },
    sortList () {
      if (this.condition.sortValue === 'asc') {
        this.condition.sortValue = 'desc'
      } else {
        this.condition.sortValue = 'asc'
      }
      this.search()
    },
    showTaskDialog (row) {
      let point = {
        x: row.LocationX,
        y: row.LocationY
      }
      this.$store.commit('diag/setSelectPoint', point)
      let routername = 'modelTask'
      if (this.$route.name === 'taskList2') {
        routername = 'modelTask2'
      }
      this.$router.push({
        name: routername,
        params: {
          id: row.TaskId
        }
      })
    },
    changeSelect (val) {
      this.batchIds = []
      val.forEach(res => {
        this.batchIds.push(res.TaskId)
      })
    },
    toBatch () {
      this.$store.commit('diag/setBatchTaskIds', this.batchIds)
      this.showBatch = true
    },
    closeBatchDialog (needRefresh) {
      this.showBatch = false
      this.batchIds = []
      this.$store.commit('diag/setBatchTaskIds', [])
      if (needRefresh === true) {
        this.$store.dispatch('diag/getTasksList')
      }
    }
  },
  components: {
    SortControl,
    batch
  }
}
</script>
<style scoped lang="scss">
.task-list {
  height: 100%;
  .header {
    height: 38px;
    overflow: hidden;
    background-color: #fff;
    padding: 0 10px;
    line-height: 36px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #dcdfe6;
    .title {
      flex-grow: 15;
    }
    .el-button {
      font-size: 16px;
      flex-grow: 1;
    }
  }
  .list-box {
    width: 100%;
    height: calc(100% - 2px);
    position: relative;
    .flex-container {
      display: flex;
      align-items: center;
      .table-text {
        flex: 1;
        width: 0;
        height: 46px;
        .text {
          line-height: 18px;
          overflow: hidden;
          display: block;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: inline-block;
        }
        .text-left {
          width: 65%;
        }
        .text-right {
          text-align: right;
          width: 33%;
        }
        .text-small {
          font-size: 13px;
          color: #666;
        }
        .completionRate {
          font-size: 16px;
          color: #4193f6;
        }
      }
    }

    .table-icon {
      width: 24px;
    }
    .svg-icon {
      font-size: 36px;
      margin-right: 14px;
    }
    .search {
      width: 170px;
    }
    .select {
      width: 170px;
    }
  }
  .buttonDiv {
    bottom: 80px;
    position: absolute;
    right: 40px;
    z-index: 999;
    .el-button {
      font-size: 30px;
    }
  }
}
</style>
